import { Env } from '../../models/env';
import { UserInfo } from '../../models/user-info';
import { AuthActions, AuthActionTypes } from '../actions/auth.actions';

export interface State {
  isAuthenticated: boolean;
  isTeamMemberAccess: boolean;
  userInfo: UserInfo | null;
  env: Env | null;
  token: string | null;
  errorMessage: string | null;
  staffViewMemberId: string | null;
  staffViewUserName: null;
  showErrorModal: boolean;
  isLoading: boolean;
}

export const initialState: State = {
  isAuthenticated: false,
  isTeamMemberAccess: false,
  userInfo: null,
  env: null,
  token: null,
  errorMessage: null,
  staffViewMemberId: null,
  staffViewUserName: null,
  showErrorModal: false,
  isLoading: false,
};

export function reducer(state = initialState, action: AuthActions): State {
  console.log(action.type, 'from reducer');
  switch (action.type) {
    case AuthActionTypes.SSO_SUCCESS: {
      return {
        ...state,
        isAuthenticated: true,
        token: action.payload.token,
        errorMessage: null,
      };
    }
    case AuthActionTypes.GET_USER_INFO_SUCCESS: {
      return {
        ...state,
        userInfo: action.payload.userInfo,
        errorMessage: null,
      };
    }
    case AuthActionTypes.INVALID_ACCESS_TOKEN: {
      return initialState;
    }
    case AuthActionTypes.USER_NOT_AUTHORIZED: {
      return {
        ...state,
        errorMessage: 'User attempting to access unauthorized service.',
      };
    }
    case AuthActionTypes.CLEAR_STORE: {
      return initialState;
    }
    case AuthActionTypes.STAFF_VIEW:
      return {
        ...state,
        staffViewMemberId: action.payload.memberId,
        staffViewUserName: action.payload.userName,
      };
    case AuthActionTypes.GENERIC_ERROR:
      return {
        ...state,
        showErrorModal: true,
      };
    case AuthActionTypes.SHOW_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case AuthActionTypes.HIDE_LOADING:
      return {
        ...state,
        isLoading: false,
      };
    default: {
      return state;
    }
  }
}
